module.exports = __webpack_public_path__ + "img/3.6b1a0d7d.jpg";